module.exports = __webpack_public_path__ + "img/1f6b4.048951b.svg";